<template>
<div class="modal-card" style="width: 650px">
    <header class="modal-card-head">
        <p class="modal-card-title">Manage Quiz</p>
        <!-- <div class="columns">
            <div class="column">
                <div>
                    <b-switch type="is-success" v-model="user.active"></b-switch>
                </div>
            </div>
        </div> -->
    </header>
    <section class="modal-card-body">
        <!--   //////////////////////////////////////////////////////// -->
        <div class="card-content">
            <div class="columns">
                <div class="column">
                    <b-field label="Question" expanded>
                        <b-input v-model="quiz.question" placeholder="Qestion"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="A" expanded>
                        <b-input  v-model="quiz.option1" placeholder="Option 1"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="B" expanded>
                        <b-input  v-model="quiz.option2" placeholder="Option 2"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="C" expanded>
                        <b-input   expanded v-model="quiz.option3" placeholder="Option 3"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="D" expanded>
                        <b-input  v-model="quiz.option4" placeholder="Option 4"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Answer" expanded>
                         <b-select placeholder="Select a character" v-model="quiz.answer" expanded>
                <option :value="quiz.option1">{{quiz.option1}}</option>
                <option :value="quiz.option2">{{quiz.option2}}</option>
                <option :value="quiz.option3">{{quiz.option3}}</option>
                <option :value="quiz.option4">{{quiz.option4}}</option>
            </b-select>
                    </b-field>
                </div>
            </div>
        </div>
        <!-- /////////////////////////////////////////////// -->
    </section>
    <footer class="modal-card-foot">
        <button class="button is-link full-width-button" style=" width: 100%;  color:white" :class="{'is-loading': isLoading}" @click="manageQuiz(quiz)">Save</button>
    </footer>
</div>
</template>

<script>
import ChapterService from './service';
import UploadService from '../../lib/UploadService';
/* import GroupService from '../settings/service' */
import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';
export default {

    name: 'addQuiz',
    props: ['propQuestion', 'chapter', 'questions'],

    created() {
        if (this.propQuestion.docId) {
            this.quiz = {
                ...this.propQuestion
            };
        }

    },

    data() {
        return {
            isLoading: false,
            
            quiz: null,
            quiz : {
            option1: null,
            option2: null,
            option3: null,
            option4: null,
            question: null,
            answer: null,

            }
        };
    },

    methods: {
        manageQuiz(quiz) {
            this.isLoading = true;
            console.log(quiz)
                ChapterService.manageQuestion(quiz.docId, this.chapter, quiz).then(() => {
                    this.isLoading = false;
                    this.$buefy.toast.open("Saved successfully");
                    this.$emit("close");
                });
                this.isLoading = false;
                this.$buefy.toast.open("Saved successfully");
                this.questions.push(quiz);
                this.$emit("close");
        },
    },

};
</script>

<style>
.zipcode-container {
    display: flex;
    justify-content: space-between;
}

.pan-image {
    height: 270px;
}
</style>



// WEBPACK FOOTER //
// src/pages/course/addQuiz.vue